import React from "react";
import { Divider, Tag, Typography } from "antd";
import { ContainerOutlined, EyeOutlined, QuestionOutlined, TrophyOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { Trans, useTranslation } from "react-i18next";
import GamePage from "./GamePage";
import "./lieing_Cubes.css";

const { Paragraph, Text, Title } = Typography;

const rankList = [
    { combos: "31, 32", color: "purple", emoji: "🟪" },
    { combos: "41, 42, 43", color: "geekblue", emoji: "🟦" },
    { combos: "51, 52, 53, 54", color: "cyan", emoji: "🟩" },
    { combos: "61, 62, 63, 64, 65", color: "green", emoji: "🟩" },
    { combos: "11, 22, 33, 44, 55, 66", color: "orange", emoji: "🟧" },
    { combos: "21", color: "gold", emoji: "⭐" },
];

const LieingCubes: React.FC = () => {
    const { t } = useTranslation();
    const rankingNotes = t("games.details.lieingCubes.rankingsNote", { returnObjects: true }) as string[];

    return (
        <GamePage
            game="lieingCubes"
            tagColor="green"
            instructionIcons={[
                <ContainerOutlined key="roll" />,
                <EyeOutlined key="peek" />,
                <QuestionOutlined key="challenge" />,
                <UserSwitchOutlined key="reveal" />,
            ]}
        >
            <section aria-labelledby="lieing-cubes-rankings-title">
                <Title level={2} id="lieing-cubes-rankings-title">
                    {t("games.details.lieingCubes.rankingsTitle")}
                </Title>
                <div className="lieing-cubes__ranking-intro">
                    <TrophyOutlined aria-hidden="true" />
                    <Title level={3}>{t("games.details.lieingCubes.rankingsIntroTitle")}</Title>
                    <Paragraph type="secondary">{t("games.details.lieingCubes.rankingsIntroDescription")}</Paragraph>
                </div>
                <div className="lieing-cubes__rank-list">
                    {rankList.slice().reverse().map((item, index) => (
                        <Tag key={item.combos} color={item.color} className={index === 0 ? "lieing-cubes__top-rank" : undefined}>
                            <span aria-hidden="true">{item.emoji}</span>
                            <span>{item.combos}{index === 0 && "  ← Highest!"}</span>
                        </Tag>
                    ))}
                </div>
                <Divider />
                <Paragraph>
                    {rankingNotes.map((line, index) => (
                        <React.Fragment key={`${line}-${index}`}>
                            <Trans
                                i18nKey={`games.details.lieingCubes.rankingsNote.${index}`}
                                components={{
                                    strong: <Text strong key="strong" />,
                                    warning: <Text type="warning" strong key="warning" />,
                                }}
                            />
                            {index < rankingNotes.length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </Paragraph>
            </section>
        </GamePage>
    );
};

export default LieingCubes;
